export default __webpack_public_path__ + "static/media/not-found.694b4357.png";